// import { takeEvery } from 'redux-saga/effects'
// import { flyerGibs as actions } from 'flux/actions'
// import { flyerGibs as api } from 'flux/api'

export default function* () {
  // yield takeEvery(actions.types.SOMETHING, doSomething)
}
